import moment from 'moment';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faBan } from "@fortawesome/free-solid-svg-icons";
import DeleteBtn from '../../../../components/buttons/DeleteBtn';
import { useTranslation } from 'react-i18next';


export default function AdminUsers({ id, fullName, email, mobilePhone, birthDate, createdAt, role, handleOnClick }) {

    moment.locale('en');
    const { t } = useTranslation();

    return (
        <tr>
            <td className="col">
                {`${moment(createdAt).format('YY')}${id.toString().padStart(3, '0')}`}
            </td>
            <td className="col">{fullName}</td>
            {/* <td className="col">
                {birthDate ? moment(birthDate).format('DD/MM/YYYY') : "--"}
            </td> */}
            <td className="col">{mobilePhone}</td>
            <td className="col">{email}</td>
            <td className={`col ${role !== "superAdmin" && "d-none"} position-relative`}>
                <DeleteBtn
                    handleOnClick={handleOnClick}
                    t={t}
                />
            </td>
        </tr>
    );
}